// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"127":"fb82b107","348":"9a2413f2","503":"43e38901","660":"78569a75","853":"fb82b107"}[chunkId] + ".css";
};